module.exports = __webpack_public_path__ + "media/images/version_merge/ring-f5ac0373eca4eea494c7fb3f1fcc0496.svg";